import { Boq } from "../Boq/Boq.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type AllureYearlyPlan = {
    id: number;
    project_id: number;
    year: string;
    prepared_by_id: number;
    checked_by_id: number;

    prepared_by: User;
    checked_by: User;
    allure_yearly_plan_items: AllureYearlyPlanItem[];
    allure_yearly_plan_statuses: AllureYearlyPlanStatus[];
};

export type AllureYearlyPlanItem = {
    id: number;
    allure_yearly_plan_id: number;
    boq_id: number;
    month_1: number;
    month_2: number;
    month_3: number;
    month_4: number;
    month_5: number;
    month_6: number;
    month_7: number;
    month_8: number;
    month_9: number;
    month_10: number;
    month_11: number;
    month_12: number;
    boq: Boq
}

export type AllureYearlyPlanStatus = {
    allure_yearly_plan_id: number;
    type: "View" | "Check" | "Approve";
    status: number;
    assigned_by: number;
    user_id: number;
    id: number;
};

export type AllureYearlyPlanStateTypes = {
    fetchAll: ApiCallState<AllureYearlyPlan[]>;
    fetchOne: ApiCallState<AllureYearlyPlan | {}>;
};

export const AllureYearlyPlanActionTypes = {
    FETCH_ALL_ALLURE_YEARLY_PLAN: "FETCH_ALL_ALLURE_YEARLY_PLAN",
    FETCH_ALL_ALLURE_YEARLY_PLAN_RESET: "FETCH_ALL_ALLURE_YEARLY_PLAN_RESET",
    FETCH_ALL_ALLURE_YEARLY_PLAN_FAILURE: "FETCH_ALL_ALLURE_YEARLY_PLAN_FAILURE",
    FETCH_ALL_ALLURE_YEARLY_PLAN_SUCCESS: "FETCH_ALL_ALLURE_YEARLY_PLAN_SUCCESS",

    FETCH_ONE_ALLURE_YEARLY_PLAN: "FETCH_ONE_ALLURE_YEARLY_PLAN",
    FETCH_ONE_ALLURE_YEARLY_PLAN_RESET: "FETCH_ONE_ALLURE_YEARLY_PLAN_RESET",
    FETCH_ONE_ALLURE_YEARLY_PLAN_FAILURE: "FETCH_ONE_ALLURE_YEARLY_PLAN_FAILURE",
    FETCH_ONE_ALLURE_YEARLY_PLAN_SUCCESS: "FETCH_ONE_ALLURE_YEARLY_PLAN_SUCCESS",
};
